import { render, staticRenderFns } from "./SelectPeriodo.vue?vue&type=template&id=8207bd44"
import script from "./SelectPeriodo.vue?vue&type=script&lang=js"
export * from "./SelectPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports